// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2_GQv","footer":"ModalUpdate_footer__QnPJv"};